import { DocumentNode } from "@apollo/client";

import { createDefaultMutationHook } from "hooks/useMutationHandler";
import useDownloadApiKeyConfig from "shared/ApiKey/useDownloadApiKeyConfig";
import { PersonalApiKeyInput } from "types/generated";

import { CREATE_PERSONAL_API_KEY } from "./gql";

type UsePersonalApiKeysCreateOptions = {
  callback?: () => void;
  refetchQueries?: DocumentNode[];
};

const usePersonalApiKeyCreateMutation = createDefaultMutationHook(CREATE_PERSONAL_API_KEY);

const usePersonalApiKeysCreate = ({ callback, refetchQueries }: UsePersonalApiKeysCreateOptions) => {
  const downloadApiKeyConfig = useDownloadApiKeyConfig();

  const [createPersonalApiKey, { loading }] = usePersonalApiKeyCreateMutation({
    refetchQueries,
    awaitRefetchQueries: true,
  });

  const onCreate = (input: PersonalApiKeyInput) => {
    createPersonalApiKey({ input }, (data) => {
      const apiKey = data?.personalApiKeyCreate;

      if (!apiKey) {
        return;
      }

      if (
        !downloadApiKeyConfig({
          id: apiKey.id,
          name: apiKey.name,
          secret: apiKey.secret,
        })
      ) {
        return;
      }

      callback?.();
    });
  };

  return { onCreate, loading };
};

export default usePersonalApiKeysCreate;
